/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Syntax_HelpInputs */

const en_admin_resource_form_syntax_help = /** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syntax Help`)
};

const de_admin_resource_form_syntax_help = /** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syntaxhilfe`)
};

const es_admin_resource_form_syntax_help = /** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda de sintaxis`)
};

const fr_admin_resource_form_syntax_help = /** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide syntaxique`)
};

/** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */
const it_admin_resource_form_syntax_help = en_admin_resource_form_syntax_help;

/** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */
const pt_br2_admin_resource_form_syntax_help = en_admin_resource_form_syntax_help;

/** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */
const pl_admin_resource_form_syntax_help = en_admin_resource_form_syntax_help;

/** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */
const hu_admin_resource_form_syntax_help = en_admin_resource_form_syntax_help;

/** @type {(inputs: Admin_Resource_Form_Syntax_HelpInputs) => LocalizedString} */
const ro_admin_resource_form_syntax_help = en_admin_resource_form_syntax_help;

/**
* | output |
* | --- |
* | "Syntax Help" |
*
* @param {Admin_Resource_Form_Syntax_HelpInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_syntax_help = /** @type {((inputs?: Admin_Resource_Form_Syntax_HelpInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Syntax_HelpInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_syntax_help(inputs)
	if (locale === "de") return de_admin_resource_form_syntax_help(inputs)
	if (locale === "es") return es_admin_resource_form_syntax_help(inputs)
	if (locale === "fr") return fr_admin_resource_form_syntax_help(inputs)
	if (locale === "it") return it_admin_resource_form_syntax_help(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_syntax_help(inputs)
	if (locale === "pl") return pl_admin_resource_form_syntax_help(inputs)
	if (locale === "hu") return hu_admin_resource_form_syntax_help(inputs)
	return ro_admin_resource_form_syntax_help(inputs)
});
export { admin_resource_form_syntax_help as "admin.resource_form.syntax_help" }